// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

/**
 * @class Jsw.Tooltip
 * @singleton
 */
export const Tooltip = {
    // show timeout
    showTimeoutStatus: true,

    // show timeout
    showTimeout: 0.55,

    // minimum viewport delta
    minDelta: 5,

    // horisonatl offset from cursor
    xOffsetLeft: -5,

    // horisonatl offset from cursor
    xOffsetRight: 5,

    // vertical offset from cursor
    yOffsetTop: 1,

    // vertical offset from cursor
    yOffsetBottom: 13,

    current: null,

    initData(contentElement) {
        let elements;

        if ('undefined' !== typeof contentElement) {
            elements = contentElement.select('.tooltipData');
        } else {
            elements = $$('.tooltipData');
        }

        elements.each(function (tooltipData) {
            Tooltip.init(tooltipData.parentNode, { element: tooltipData });
        });
    },

    /**
     * @param {Element} element
     * @param {Object} config Tooltip config.
     * @param {String} config.text Text of tooltip.
     * @returns {Jsw.Tooltip.Instance}
     */
    init(element, config) {
        return new Tooltip.Instance(element, config);
    },

    set(tooltip) {
        if (Tooltip.current && Tooltip.current !== tooltip) {
            Tooltip.hide();
        }
        if (Tooltip.current === tooltip) {
            return;
        }
        Tooltip.current = tooltip;
        Element.observe(tooltip.element, 'mousemove', Tooltip._onMouseMove);
        Element.observe(tooltip.element, 'mouseout', Tooltip._onMouseOut);

        Tooltip.show();
    },

    show() {
        Tooltip.showCancel();
        Tooltip.hideCancel();
        if (Tooltip.showTimeoutStatus) {
            Tooltip.showTask = new PeriodicalExecuter(Tooltip.showFinish, Tooltip.showTimeout);
        } else {
            Tooltip.showFinish();
        }
    },

    showCancel() {
        if (Tooltip.showTask) {
            Tooltip.showTask.stop();
            Tooltip.showTask = null;
        }
    },

    showFinish() {
        Tooltip.showCancel();
        const tooltipElement = Tooltip._fetchTooltipElement();
        const tooltip = Tooltip.current;
        if (tooltip.config.text) {
            tooltipElement.down('span').update(tooltip.config.text.toString().escapeHTML());
        } else if (tooltip.config.element) {
            tooltipElement.down('span').update(tooltip.config.element.innerHTML);
        }
        tooltipElement.show();
        Tooltip.update();
    },

    hide() {
        Tooltip.showCancel();
        if (!Tooltip.current) {
            return;
        }
        const tooltip = Tooltip.current;
        Tooltip.current = null;
        const tooltipElement = Tooltip._fetchTooltipElement();
        tooltipElement.hide();
        Element.stopObserving(tooltip.element, 'mousemove', Tooltip._onMouseMove);
        Element.stopObserving(tooltip.element, 'mouseout', Tooltip._onMouseOut);
        Tooltip.hideTask = new PeriodicalExecuter(Tooltip.hideFinish, Tooltip.showTimeout);
    },

    hideCancel() {
        if (Tooltip.hideTask) {
            Tooltip.hideTask.stop();
            Tooltip.hideTask = null;
        }
    },

    hideFinish() {
        Tooltip.showTimeoutStatus = true;
    },

    update() {
        if (!Tooltip.current) {
            return;
        }
        const tooltipElement = Tooltip._fetchTooltipElement();
        const position = Tooltip._fetchTooltipPosition(tooltipElement);
        Element.setStyle(tooltipElement, {
            top: `${position.y}px`,
            left: `${position.x}px`,
        });
    },

    _onMouseOut() {
        Tooltip.hide();
    },

    _onMouseMove(event) {
        Tooltip.tooltipX = Event.pointerX(event);
        Tooltip.tooltipY = Event.pointerY(event);
        Tooltip.update();
    },

    _fetchTooltipElement() {
        if (!Tooltip._tooltipElement) {
            const el = document.createElement('div');
            el.className = 'tooltip';
            el.innerHTML = '<b><i><i><i><span></span></i></i></i></b>';
            el.hide();
            document.body.appendChild(el);
            Tooltip._tooltipElement = el;
        }

        return Tooltip._tooltipElement;
    },

    _fetchTooltipPosition(tooltipElement) {
        let x = Tooltip.tooltipX;
        let y = Tooltip.tooltipY;

        const tDim = Element.getDimensions(tooltipElement);
        const vDim = document.viewport.getDimensions();
        const vScr = document.viewport.getScrollOffsets();

        const freeRight = vDim.width + vScr.left - Tooltip.tooltipX;
        const freeLeft = Tooltip.tooltipX - vScr.left;
        const freeTop = Tooltip.tooltipY - vScr.top;
        const freeBottom = vDim.height + vScr.top - Tooltip.tooltipY;

        // apply better x
        if (freeRight > tDim.width + Tooltip.minDelta + Tooltip.xOffsetRight) {
            x = Tooltip.tooltipX + Tooltip.xOffsetRight;
        } else if (freeLeft > tDim.width + Tooltip.minDelta + Tooltip.xOffsetLeft) {
            x = Tooltip.tooltipX - tDim.width - Tooltip.xOffsetLeft;
        } else {
            x = Tooltip.tooltipX - ((tDim.width + Tooltip.xOffsetLeft) / 2);
        }

        // apply better y
        if (freeBottom > tDim.height + Tooltip.minDelta + Tooltip.yOffsetBottom) {
            y = Tooltip.tooltipY + Tooltip.yOffsetBottom;
        } else if (freeTop > tDim.height + Tooltip.minDelta + Tooltip.yOffsetTop) {
            y = Tooltip.tooltipY - tDim.height - Tooltip.yOffsetTop;
        } else {
            y = Tooltip.tooltipY - ((tDim.height + Tooltip.yOffsetTop) / 2);
        }
        if (x < 0) {
            x = Tooltip.minDelta;
        }

        return { x, y };
    },
};

Event.observe(window, 'load', function () {
    Tooltip.initData();
});

/**
 * @class Jsw.Tooltip.Instance
 */
Tooltip.Instance = class {
    constructor(element, config) {
        this.element = element;
        this.config = config;

        // observe events
        Event.stopObserving(this.element, 'mouseover');
        Event.observe(this.element, 'mouseover', this.set.bind(this));
    }

    set() {
        Tooltip.set(this);
    }

    setText(text) {
        this.config.text = text.toString().escapeHTML();
    }
};



// WEBPACK FOOTER //
// ./jsw/tooltip.js